export default __webpack_public_path__ + "static/media/moskolWebLogo.0120262c.png";